import ScrollHelper from './_ScrollHelper.js'

let requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
let callbacks = [];
let running = false;

let scroll = function () {
  if (!running) {
    running = true;

    if (window.requestAnimationFrame) {

      window.requestAnimationFrame(runCallbacks);
    } else {
      setTimeout(runCallbacks, 66);
    }
  }
};

let runCallbacks = function () {
  callbacks.forEach(function (callback) {
    callback(this);
  });

  running = false;
};

let addCallback = function (callback) {
  if (callback) {
    callbacks.push(callback);
  }
};

class ScrollDirection {
  constructor(callback, settings){
    this.callback = callback
    this.direction = null
    this.scrolltop = 0
    this.startposition = settings.startposition || 0
    this.trigerpoint = settings.trigerpoint || 0
    this.threshold = settings.threshold || 40
    this.scroll = new ScrollHelper( this.scroll.bind(this) );
  }

  scroll() {
    this.scrolltop = document.scrollingElement.scrollTop
    
    const delta = this.trigerpoint - this.scrolltop

    
    if(Math.abs(delta) >= this.threshold && this.scrolltop >= this.startposition) {
      this.trigerpoint = this.scrolltop
      this.updateDirection(delta)
    } else if(this.scrolltop <= this.startposition) {
      this.force()
    }
  }
  updateDirection(delta) {
    const direction = Math.sign(delta)
    if(this.direction !== direction) {
      this.direction = direction
      this.applyCallback(this.direction)
    }
  }
  force() {
    this.direction = 1
    this.applyCallback(1)
  }
  applyCallback(direction) {
    this.callback(this.direction === 1 ? 'up' : 'down')
  }
  destroy(){
    window.removeEventListener('scroll', scroll);

  }
}

export default ScrollDirection;

